export default __webpack_public_path__ + "static/media/thainight5.b4dbbf9e.jpg";